import {useState, useEffect} from "react";
import React from "react";
import {connect} from "react-redux";
import {
    DEFAULT_TEMPLATE_VERSION,
    MOBILE_TEMPLATE_VERSION,
    CATEGORIES_PAGE,
} from "@/utils/constants";
import MobileHeader from "../Mobile/Layout/Header/Header";
import DefaultHeader from "../Default/Layout/Header/Header";
import MenuContainer from "../Default/Common/Menu/MenuContainer";
import MobileFooter from "../Mobile/Layout/Footer/Footer";
import DefaultFooter from "../Default/Layout/Footer/Footer";
import BannerBloc from "../Default/Layout/Header/BannerBloc";
import {getCustomMenu} from "@/redux/reducers/responsive/common/CommonActions";
import {getPageClassName} from "./customerAccount/PrefetchDataPages"

const ResponsiveLayout = (props) => {

    const {
        templateVersion,
        context,
        children,
        pathName,
        shopCircleVersion,
        footerTrackingFlow,
        currentStep,
        footerTrackingScopeData,
        headerTrackingScopeData,
        logoVersion,
        googleMapsKey,
        isDQENormalisationActive,
        bannersBlocList,
        showBanners,
        ssr
    } = props;
    const [menuItems, setMenuItems] = useState(props.menuItems);
    const [aboveMenuItems, setAboveMenuItems] = useState(props.aboveMenuItems);
    const pageClassName = getPageClassName(pathName)
    useEffect(() => {
        if (!ssr) {
            // TODO Déplacer getCustomMenu dans l'action et faire les adaptations
            getCustomMenu(templateVersion, navigator.userAgent, null, false, '', false).then((response) => {
                setMenuItems(response.menuItems.values)
                templateVersion === DEFAULT_TEMPLATE_VERSION ? setAboveMenuItems(response.aboveMenuItems?.values) : setAboveMenuItems([])
            })
        }
    }, [])

    return (

        <div className={pageClassName ? pageClassName : ''} id="page" data-template-version={templateVersion}>
            {templateVersion === MOBILE_TEMPLATE_VERSION ?
                <>
                    <MobileHeader context={currentStep}
                                  menuItems={ssr ? props.menuItems : menuItems}
                                  wordingVersion={MOBILE_TEMPLATE_VERSION}
                                  currentPage={context}
                                  headerTrackingScopeData={headerTrackingScopeData}
                                  logoVersion={logoVersion}
                                  googleMapsKey={googleMapsKey}
                                  shopCircleVersion={shopCircleVersion}
                                  isDQENormalisationActive={isDQENormalisationActive}
                    />
                    {children}
                    <MobileFooter/>
                </> : <>
                    <header id="main-header" className={"main-header"}>
                        <div id="main-header__infobar" className="main-header__infobar owl-carousel owl-loaded">
                            <BannerBloc showBanners={showBanners} bannersBlocList={bannersBlocList}/>
                        </div>
                        <DefaultHeader currentStep={currentStep}
                                       shopCircleVersion={shopCircleVersion}
                                       headerTrackingScopeData={headerTrackingScopeData}
                                       logoVersion={logoVersion}
                        />
                        <MenuContainer menuItems={ssr ? props.menuItems : menuItems}
                                       aboveMenuItems={ssr ? props.aboveMenuItems : aboveMenuItems}
                                       currentPage={context}/>
                    </header>
                    {children}
                    <footer id="container_footer">
                        <div id="footer">
                            <DefaultFooter footerTrackingFlow={footerTrackingFlow}
                                           footerTrackingScopeData={footerTrackingScopeData}/>
                        </div>
                    </footer>
                </>}
        </div>
    );

}

const mapStateToProps = (state, ownProps) => {
    return {

        templateVersion: ownProps.templateVersion,
        currentStep: ownProps.currentStep,
        footerTrackingFlow: state.tracking.footerTrackingFlow,
        menuItems: ownProps.menuItems ?? [],
        aboveMenuItems: ownProps.aboveMenuItems ?? [],
        headerTrackingScopeData: ownProps.headerTrackingScopeData ?? null,
        footerTrackingScopeData: ownProps.footerTrackingScopeData ?? null,
        isDQENormalisationActive: ownProps.isDQENormalisationActive ?? null,
        googleMapsKey: ownProps.googleMapsKey ?? null,
        shopCircleVersion: ownProps.shopCircleVersion ?? null,
        logoVersion: ownProps.logoVersion ?? null,
        bannersBlocList: ownProps.bannersBlocList ?? null,
        showBanners: ownProps.showBanners ?? null,
    }
}

export default connect(mapStateToProps, null)(ResponsiveLayout);